<template>
  <step-container title="Todas las memoorias incluyen:" :auto-scroll="false">
    <detail-card
      title="Memoory Maker"
      description="Creador de entrevista colaborativo para que invites a quien quieras a participar dejando preguntas y dedicatorias"
      :image="{
        src: memooryMakerIllustration,
        alt: 'Creación de entrevista colaborativo',
        width: 180,
        height: 120,
      }"
    />

    <detail-card
      title="Memoory Keeper"
      description="Entrevistador especializado, que conduce la conversación y edición profesional de video"
      :image="{
        src: interviewIllustration,
        alt: 'Entrevista especializada',
        width: 180,
        height: 120,
      }"
    />

    <detail-card
      title="Entrega de perfil privado"
      description="Acompañado de los capítulos, fotos y dedicatorias"
      :image="{
        src: profilePreviewIllustration,
        alt: 'Perfil de Memoorias',
        width: 180,
        height: 120,
      }"
    />
  </step-container>
</template>

<script setup>
import memooryMakerIllustration from "@assets/images/quotation/colab-prepare-interview.svg";
import interviewIllustration from "@assets/images/quotation/interview.svg";
import profilePreviewIllustration from "@assets/images/quotation/profile-login.svg";
</script>

<script>
import stepMixin from "../../mixins/step";

import DetailCard from "../layouts/DetailCard.vue";

export default {
  mixins: [stepMixin],

  components: { DetailCard },
};
</script>
